module.exports = __webpack_public_path__ + "static/media/auto-ewallet.ae0bfa82.jpg";